import React, { useEffect } from "react";
import "./style.scss";
import { FileIcon } from "../../components/svgs";
import { useStore } from "../../store";
import { observer } from "mobx-react-lite";
import { Col, Row, Grid } from "antd";

const { useBreakpoint } = Grid;

const Resources: React.FC = observer(() => {
  const { md } = useBreakpoint();
  const { resourcesStore } = useStore();
  const { getFiles, files, getResources, resources } = resourcesStore;

  useEffect(() => {
    getFiles();
    getResources();
    // eslint-disable-next-line
  }, []);

  const trackDownload = () => {
    const sessionId = localStorage.getItem("sessionId");
    if (sessionId) {
      resourcesStore.trackDownload({ sessionId });
    }
  };

  return (
    <div className="flex justify-center">
      <div className="w-full flex-col items-center max-w-270">
        <span className={`mt-10 form-title ${!md ? "text-center" : ""}`}>
          Resources & Example Work
        </span>
        <span className={`mt-4 mb-10 ${!md ? "text-center" : ""}`}>
          Work examples and guidelines provided to help you start your project
        </span>

        <h1 className={`w-full text-left ${!md ? "text-center" : ""}`}>
          Example Work
        </h1>
        <Row gutter={[16, 8]} className="max-w-270 w-full mb-8">
          {files.map((file, i) => (
            <Col key={i} lg={8} md={12} sm={24} xs={24} className="my-2">
              <div
                key={i}
                className="bg-primary border-primary rounded-4 resource-card"
              >
                <div className="gap-8 flex-col m-8">
                  <div className="flex gap-2">
                    {md && <FileIcon />}
                    <div className="flex-col gap-2">
                      <span className="font-size-5 font-weight-700">
                        {file.name}
                      </span>
                      <span className="font-siae-4 font-weight-400">
                        {file.description}
                      </span>
                    </div>
                  </div>
                  <a
                    href={file.link}
                    className="font-size-4 font-weight-700 download-link"
                    onClick={() => trackDownload()}
                  >
                    Download File
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        <h1 className={`w-full text-left ${!md ? "text-center" : ""}`}>
          Resources
        </h1>
        <Row gutter={[32, 16]} className="max-w-270 w-full">
          {resources.map((resource, i) => (
            <Col key={i} md={12} sm={24} xs={24} className="my-2">
              <div className="bg-primary border-primary rounded-4 resource-card">
                <div className="gap-8 m-8 flex-col">
                  <div className="flex-col gap-2">
                    <span className="font-size-5 font-weight-700">
                      {resource.name}
                    </span>
                    <span className="font-siae-4 font-weight-400">
                      {resource.description}
                    </span>
                  </div>
                  <a
                    href={resource?.files?.[0]?.link}
                    className="font-size-4 font-weight-700 download-link"
                    onClick={() => trackDownload()}
                  >
                    Download File
                  </a>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
});

export default Resources;
